export default __webpack_public_path__ + "static/media/comference_room.8c4df692.png";